import { useAuth0 } from '@auth0/auth0-react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createRootRouteWithContext, HeadContent, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { Toaster } from '@tempo-io/sui-sonner';
import { NotFoundError } from '@/common/components/error/NotFoundError';
import { ThemeProvider, useTheme } from '@/common/components/ThemeProvider';
import { resolveDocumentHead } from '@/common/utils/documentTitle';
import type { RouterContext } from '@/router';

export const Route = createRootRouteWithContext<RouterContext>()({
  head: ({ matches }) => resolveDocumentHead(matches),
  component: () => {
    return (
      <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
        <RootComponent />
      </ThemeProvider>
    );
  },
  notFoundComponent: NotFoundError,
});

function RootComponent() {
  const { isLoading } = useAuth0();
  const { appliedTheme } = useTheme();

  if (isLoading) {
    return <HeadContent />;
  }

  return (
    <>
      <HeadContent />
      <div data-testid="e2e-authenticated" className="flex h-screen">
        {!isLoading && <Outlet />}
      </div>
      <Toaster theme={appliedTheme} position="bottom-left" />
      <ReactQueryDevtools initialIsOpen={false} />
      <TanStackRouterDevtools position="bottom-right" />
    </>
  );
}
